import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshirdicabfare() {



  const cardData =
  {
    keyword: ' Pune to Shirdi Cab Fare',
    heading: 'Sai Trupti Cabs: Pune to Shirdi Cab Fare',
    headingDescription: 'Sai Trupti Cabs offers affordable and transparent Pune to Shirdi cab fare options, ensuring a smooth and comfortable journey for every devotee visiting Sai Baba’s holy temple. Our fares are designed to suit all budgets, with Sedan cabs starting at reasonable rates and SUV or Luxury options available for families and group travelers. Each cab is air-conditioned, clean, and equipped for long-distance comfort, while our professional and background-verified chauffeurs ensure safe and punctual travel. With Sai Trupti Cabs, you pay only for what you travel—no hidden charges or extra costs. Whether you choose a one-way or round-trip package, we guarantee the best Pune to Shirdi cab fare with top-notch service, 24×7 support, and complete peace of mind throughout your spiritual journey.',

    top: 'Top Places to Visit in Shirdi with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "The Sai Baba Samadhi Mandir is the sacred heart of Shirdi and the most revered pilgrimage site in Maharashtra. Built in marble, it houses the resting place of Shri Sai Baba, radiating peace and divine energy. Devotees from across the world visit daily to offer prayers and witness the mesmerizing aarti ceremonies. The temple’s white marble statue of Sai Baba exudes serenity and compassion, reminding visitors of his eternal teachings of love, unity, and selfless service."
  },
  {
    "title": "Dwarkamai Mosque",
    "description": "Dwarkamai Mosque holds immense spiritual importance as Sai Baba lived here for over 60 years. This humble structure symbolizes faith, patience, and divine grace, where Baba healed the sick and helped the needy. The sacred dhuni (eternal flame) still burns here, representing purity and spiritual continuity. Devotees visit Dwarkamai to experience Baba’s living presence and witness the divine simplicity that continues to guide millions of hearts toward goodness and truth."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is another significant shrine in Shirdi, where Sai Baba spent every alternate night during the last years of his life. The place still preserves his wooden bed, palkhi, and photographs that recreate the divine aura of his presence. The traditional palkhi procession from Dwarkamai to Chavadi is a highlight for devotees, reflecting the deep bond between the saint and his followers. It stands as a timeless reminder of discipline, devotion, and divine grace."
  },
  {
    "title": "Gurusthan",
    "description": "Gurusthan marks the exact spot where Sai Baba was first seen as a young boy meditating under a neem tree. Today, a small shrine with a marble statue of Baba and a sacred Shivling draws thousands of visitors seeking spiritual awakening. The neem tree’s roots are believed to have miraculous healing powers. Gurusthan beautifully connects Shirdi’s divine past with the living devotion of its present, inspiring faith and humility among pilgrims."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a serene garden where Sai Baba spent time daily, watering plants and meditating under trees. The garden still houses the lamp lit by Baba, which continues to burn eternally in his memory. Shaded paths, tranquil surroundings, and the fragrance of flowers make it a peaceful retreat for devotees. Lendi Baug reflects Baba’s deep love for nature and simplicity, reminding visitors that spirituality thrives in acts of care and compassion."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple holds historical importance as the place where Sai Baba first arrived in Shirdi and was affectionately addressed as 'Ya Sai' by the temple priest. Dedicated to Lord Khandoba, the temple signifies the moment when Baba’s divine journey in Shirdi began. Pilgrims visit this modest shrine to pay homage to both Lord Khandoba and Sai Baba’s first blessing in the town. It’s a sacred site connecting faith, history, and divine destiny."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is an open-air museum that artistically depicts the life and miracles of Sai Baba through realistic sculptures and dioramas. The peaceful environment, traditional architecture, and storytelling displays offer a beautiful blend of devotion and learning. Visitors, especially families, find it a perfect place to understand Baba’s message in a visual and interactive way. The village also features play areas and food stalls, making it a wholesome spiritual retreat."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy Water Park offers a refreshing contrast to Shirdi’s spiritual ambiance, providing family-friendly entertainment and relaxation. Spread across 10 acres, it features thrilling slides, a wave pool, and dedicated zones for kids. After a divine darshan, visitors often unwind here to enjoy fun-filled moments with family. Its cleanliness, safety measures, and proximity to the temple make it one of Shirdi’s most popular leisure destinations."
  },
  {
    "title": "Dixit Wada Museum",
    "description": "Located within the Sai Baba Temple complex, Dixit Wada Museum showcases a collection of Sai Baba’s personal belongings — robes, utensils, footwear, and rare photographs. The museum preserves Baba’s legacy and offers a glimpse into his simple, ascetic lifestyle. Visitors feel a deep connection as they view artifacts that once touched the saint’s life. It’s a must-visit for devotees seeking to understand Sai Baba’s humility and timeless wisdom."
  },
  {
    "title": "Shani Shingnapur Temple",
    "description": "Located about 70 km from Shirdi, Shani Shingnapur Temple is dedicated to Lord Shani and is famous for its unique open-air shrine where no door or lock exists in the entire village. The belief that Lord Shani protects every devotee instills immense faith among visitors. Pilgrims often combine their Shirdi darshan with a visit here, completing a spiritually enriching journey. The temple’s aura of trust and divine justice continues to attract devotees from all over India."
  }
],



"services": [
  {
    "name": "Pune to Shirdi Cab Fare",
    "description": "Pune to Shirdi Cab Fare provides transparent pricing for cab services from Pune to Shirdi. Fares depend on vehicle type, distance, and service type, ensuring affordable and reliable travel for all passengers."
  },
  {
    "name": "Pune to Shirdi Taxi Fare",
    "description": "Pune to Shirdi Taxi Fare offers clear and upfront pricing for taxi services, including one-way and round trips. Fares are calculated based on distance, type of car, and additional services."
  },
  {
    "name": "Pune to Shirdi Car Hire Cost",
    "description": "Pune to Shirdi Car Hire Cost gives detailed pricing for renting cars with professional drivers or self-drive options. Costs vary with car type, rental duration, and extra amenities."
  },
  {
    "name": "Pune to Shirdi Innova Fare",
    "description": "Pune to Shirdi Innova Fare provides cost estimates for traveling in spacious and comfortable Innova vehicles, with transparent pricing, AC service, and optional extras for a smooth journey."
  },
  {
    "name": "Pune to Shirdi Ertiga Fare",
    "description": "Pune to Shirdi Ertiga Fare gives fare details for Ertiga cab services, suitable for families and small groups. Pricing includes AC, driver charges, and tolls for a hassle-free trip."
  },
  {
    "name": "Pune to Shirdi Sedan Fare",
    "description": "Pune to Shirdi Sedan Fare ensures clear pricing for Sedan cab rides with comfortable interiors, AC service, and professional drivers, providing a convenient travel option."
  },
  {
    "name": "Pune to Shirdi One Way Fare",
    "description": "Pune to Shirdi One Way Fare offers accurate cost estimates for one-way trips from Pune to Shirdi, with pricing depending on vehicle type, distance, and service level."
  },
  {
    "name": "Pune to Shirdi Drop Taxi Fare",
    "description": "Pune to Shirdi Drop Taxi Fare provides transparent pricing for point-to-point drop services, including AC cars, driver charges, and optional luxury vehicles."
  },
  {
    "name": "Pune to Shirdi Luxury Cab Fare",
    "description": "Pune to Shirdi Luxury Cab Fare gives cost details for premium travel in high-end vehicles with professional chauffeurs, AC, and comfort-focused amenities."
  },
  {
    "name": "Pune to Shirdi Outstation Fare",
    "description": "Pune to Shirdi Outstation Fare provides fare estimates for long-distance travel, including tolls, driver allowances, and vehicle options for a safe and comfortable journey."
  },
  {
    "name": "Affordable Pune to Shirdi Cab",
    "description": "Affordable Pune to Shirdi Cab offers budget-friendly fare options without compromising comfort, including AC vehicles, professional drivers, and transparent pricing."
  },
  {
    "name": "Pune to Shirdi AC Cab Fare",
    "description": "Pune to Shirdi AC Cab Fare details costs for air-conditioned rides from Pune to Shirdi, ensuring a comfortable journey with transparent pricing and reliable service."
  },
  {
    "name": "Pune to Shirdi Online Booking Fare",
    "description": "Pune to Shirdi Online Booking Fare provides instant fare estimates during online cab booking, including multiple vehicle options, transparent pricing, and secure payment methods."
  },
  {
    "name": "Pune to Shirdi Travel Cost",
    "description": "Pune to Shirdi Travel Cost covers overall cost planning for trips, including cab fare, tolls, driver allowances, and additional travel expenses for a hassle-free journey."
  },
  {
    "name": "Pune to Shirdi Car Rental Fare",
    "description": "Pune to Shirdi Car Rental Fare provides detailed cost breakdown for renting vehicles for travel to Shirdi, including AC cars, Sedans, Innova, and Ertiga options with transparent pricing."
  }
],
"tableData": [
  ["Pune to Shirdi Cab Fare", "Pune to Shirdi Taxi Fare"],
  ["Pune to Shirdi Car Hire Cost", "Pune to Shirdi Innova Fare"],
  ["Pune to Shirdi Ertiga Fare", "Pune to Shirdi Sedan Fare"],
  ["Pune to Shirdi One Way Fare", "Pune to Shirdi Drop Taxi Fare"],
  ["Pune to Shirdi Luxury Cab Fare", "Pune to Shirdi Outstation Fare"],
  ["Affordable Pune to Shirdi Cab", "Pune to Shirdi AC Cab Fare"],
  ["Pune to Shirdi Online Booking Fare", "Pune to Shirdi Travel Cost"],
  ["Pune to Shirdi Car Rental Fare", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Shirdi Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd offers reliable and comfortable cab services from Pune to Shirdi — ideal for pilgrimage, family travel or leisure road trips."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "We offer clear one‑way fare estimates from Pune to Shirdi, starting at approx. ₹2,100–₹2,500 for sedans. :contentReference[oaicite:1]{index=1}"
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs or premium cars to suit your group size, luggage and comfort preferences for the Pune to Shirdi route. :contentReference[oaicite:2]{index=2}"
  },
  {
    "WhyChooseheading": "Experienced & Punctual Drivers",
    "WhyChoosedescription": "Our courteous, professional drivers are familiar with the Pune‑to‑Shirdi route, ensuring a safe, smooth and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide convenient pickups from anywhere in Pune (city, airport, suburbs) and drop‑offs in Shirdi (town, railway station, temple vicinity)."
  },
  {
    "WhyChooseheading": "Clean, Well‑Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized and maintained to ensure comfort and reliability for the longer drive from Pune to Shirdi."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, route planning or any travel changes."
  },
  {
    "WhyChooseheading": "Hassle‑Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Shirdi cab easily via call, WhatsApp or our website — with instant confirmation and prompt vehicle dispatch."
  }
]




































  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  provide Pune to Shirdi cab fare details?',
    answer: 'Yes, Sai Trupti Cabs  provides transparent Pune to Shirdi cab fares for one way, round trip, and group travel, depending on vehicle type and distance.',
  },
  {
    question: 'How can I know the Pune to Shirdi cab fare before booking?',
    answer: 'You can check the estimated fare on our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What is the approximate fare for a Pune to Shirdi cab?',
    answer: 'Our cab fares start from ₹2,000 for sedans, ₹2,500–₹3,500 for SUVs and Innova Crysta, depending on vehicle type, group size, and travel requirements.',
  },
  {
    question: 'Are there any extra charges for Pune to Shirdi cab service?',
    answer: 'Extra charges may apply for tolls, night travel, extra kilometers, or additional waiting time. Our team will clarify all charges at the time of booking.',
  },
  {
    question: 'Can I get a fare estimate for different types of cabs?',
    answer: 'Certainly. We provide fare estimates for hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and luxury cabs to help you choose the best option.',
  },
  {
    question: 'Is the Pune to Shirdi cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services between Pune and Shirdi for flexible travel plans.',
  },
  {
    question: 'What payment methods are accepted for Pune to Shirdi cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Shirdi cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure journey.',
  },
  {
    question: 'Can I get customer support during the Pune to Shirdi cab journey?',
    answer: 'Yes, our dedicated 24×7 customer support team is available to assist you throughout your Pune to Shirdi cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Joshi',
    feedback: 'I booked a Pune to Shirdi cab with Sai Trupti Cabs. The ride was comfortable, and the driver was very professional and punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Sai Trupti Cabs provided excellent service for our Pune to Shirdi trip. Smooth journey and very courteous driver.',
    rating: 5,
  },
];































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Cab Fare",
  "image": "https://saitrupticabs.com/assets/images/pune-to-shirdi-cab.jpg",
  "description": "Check Pune to Shirdi Cab Fare with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15864"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-shirdi-cab"
  }
};






  return (
    <div>
      <Helmet>
  <title>Pune to Shirdi Cab Fare | Affordable & Transparent | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Check Pune to Shirdi Cab Fare with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking." 
  />
  <meta 
    name="keywords" 
    content="Pune to Shirdi Cab Fare, Pune to Shirdi Taxi Fare, Pune to Shirdi Car Hire Cost, Pune to Shirdi Innova Fare, Pune to Shirdi Ertiga Fare, Pune to Shirdi Sedan Fare, Pune to Shirdi One Way Fare, Pune to Shirdi Drop Taxi Fare, Pune to Shirdi Luxury Cab Fare, Pune to Shirdi Outstation Fare, Affordable Pune to Shirdi Cab, Pune to Shirdi AC Cab Fare, Pune to Shirdi Online Booking Fare, Pune to Shirdi Travel Cost, Pune to Shirdi Car Rental Fare" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/newimages/8.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoshirdicabfare;